import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BlogsLayout from './BlogsLayout';
import SchoolBlogs from './school-blogs/index';
import ParentsViewed from './parents-viewed/index';
import Questionnaire from './questionnaire/index';

const Blogs: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<BlogsLayout />}>
                <Route index element={<Navigate to="school-blogs" replace />} />
                <Route path="school-blogs" element={<SchoolBlogs />} />
                <Route path="parents-viewed" element={<ParentsViewed />} />
                <Route path="questionnaire" element={<Questionnaire />} />
            </Route>
        </Routes>
    );
};

export default Blogs;
